import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/execution-authorization/page.tsx");
